export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openStaffForm({commit}) {
        commit('setStaffFormOpen');
    },
    closeStaffForm({commit}) {
        commit('setStaffFormClose');
    },

    openEducationForm({commit}) {
        commit('setEducationFormOpen');
    },
    closeEducationForm({commit}) {
        commit('setEducationFormClose');
    },

    openFeeForm({commit}) {
        commit('setFeeFormOpen');
    },
    closeFeeForm({commit}) {
        commit('setFeeFormClose');
    }
}
